import { render, staticRenderFns } from "./PlusTvBannerCarousel.vue?vue&type=template&id=c9112836&scoped=true"
import script from "./PlusTvBannerCarousel.vue?vue&type=script&lang=js"
export * from "./PlusTvBannerCarousel.vue?vue&type=script&lang=js"
import style0 from "./PlusTvBannerCarousel.vue?vue&type=style&index=0&id=c9112836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9112836",
  null
  
)

export default component.exports